import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { useContent } from "../../hooks/UseContentHook";
import { ComponentTestPage, ComponentTestPageProps } from "./ComponentTestPage";

export const EMPTY_PAGE_CONTENT: ComponentTestPageProps = {};

export const ComponentTestPageContainer: React.FC<RouteComponentProps> = routeProps => {
  const { content } = useContent<ComponentTestPageProps>("ComponentTestPage", EMPTY_PAGE_CONTENT);
  return <ComponentTestPage {...routeProps} {...content} />;
};
